S.swiper = {
        config: {
            loop: true,
        },

        elements: {
            $swiperContainer: null,
            $swiperPagination: null,
        },
        /** var {jQuery} $swiper */
        $swiper: null,

        init()
        {
            this.initSwiper();
        },

        /** initSwiper */
        initSwiper()
        {
            this.$swiper = new Swiper(this.elements.$swiperContainer, {
                // per css config
                // slidesPerView: 3,
                slidesPerView: 'auto',
                speed: 600,
                centeredSlides: true,
                loop: this.config.loop,

                keyboard: {
                    enabled: true,
                },

                /** pagination optional */
                pagination: {
                    el: this.elements.$swiperPagination,
                    clickable: true,
                },

                navigation: {
                    nextEl: this.$module.find('.swiper-button-next'),
                    prevEl: this.$module.find('.swiper-button-prev'),
                },

                watchSlidesVisibility: true,
                preloadImages: false,
                lazy: true,
            });
        },
    };